import React, { useContext } from 'react'
import './style.scss'
// import QuickItems from '../../../components/MyBiye/QuickItems/Index'
import Icon from 'react-icons-kit'
import { edit2 } from 'react-icons-kit/feather'
// import { Images } from "../../../utils/Images"
// import { u0031, u0032, u0033 } from 'react-icons-kit/noto_emoji_regular'
// import { checkCircle } from 'react-icons-kit/feather'
import { UserContext } from '../../../utils/context/userContext'
// import Loading from '../../../components/Loading/Index'
import { useNavigate } from 'react-router-dom'
const Index = () => {

    const { user } = useContext(UserContext)
    let history = useNavigate();
    let myContact = user?.contactInformation

    const changeUrl = () => {
        history.push('/my-metrimony/profile?dv=con')
    }

    // if (!user) return <Loading />

    return (
        <div className="contact-container">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="d-lg-flex">
                            {/* <QuickItems /> */}
                            <div className="flex-fill main-section px-lg-4 pb-4">
                                {/* hello  */}
                                <div className="row">
                                    <div className="col-12 col-lg-12">
                                        <div className="card shadow contact-card mt-4" >
                                            <div className="card-header px-4 py-2 pt-3 pb-0">
                                                <div className="d-flex ">
                                                    <div className="mb-0"><h5 >Contact Number</h5></div>
                                                    <div className="ml-auto ">
                                                        <button className="btn rounded shadow"
                                                            onClick={changeUrl}
                                                        >
                                                            <Icon icon={edit2} size={20} />Edit
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card-body px-5">
                                                <div className="row" >
                                                    <div className=" col-12 col-lg-6 ">
                                                        <table className="font-size-base">
                                                            <thead>
                                                                <tr>
                                                                    <th>Mobile No</th>
                                                                    <td className="pl-5">:</td>
                                                                    <td >{user?.phone ? user?.phone : " --- "}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>Contact Person</th>
                                                                    <td className="pl-5">:</td>
                                                                    <td>{myContact?.contactPersonName ? myContact?.contactPersonName : " --- "}</td>
                                                                </tr>
                                                            </thead>
                                                        </table>
                                                    </div>
                                                    <div className='col-12 col-lg-6'>
                                                    <table className="font-size-base">
                                                            <thead>
                                                                <tr>
                                                                    <th>Relationship with this person</th>
                                                                    <td className="pl-5">:</td>
                                                                    <td>{myContact?.relationship ? myContact?.relationship : " --- "}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>Convineant time to call</th>
                                                                    <td className="pl-5">:</td>
                                                                    <td>{myContact?.convenientTimeToCall ? myContact.convenientTimeToCall : "---"}</td>
                                                                </tr>
                                                            </thead>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Index;